import { create } from 'zustand'

// Global embedded-player state: any component (search chips, document viewer,
// transcript panel) can open the source video at a timestamp without prop
// drilling — the single <VideoPlayerModal/> lives in Layout.
//
// payload: { source_url, origin, video_id?, title?, start? (seconds) }
const usePlayerStore = create((set) => ({
  video: null,
  openPlayer: (payload) => set({ video: payload }),
  closePlayer: () => set({ video: null }),
}))

export default usePlayerStore
